module.exports = __webpack_public_path__ + "img/frase_balao_5.d5f047c8.svg";